import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const CTASection = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Vind Je Innerlijke Balans */}
      <section className="relative py-28 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/87703a8d33267e9b300ce79d02c2578f.jpg"
            alt="Inner balance"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#050010]/70 via-[#050010]/50 to-[#050010]/80" />
        </div>
        <div className="relative z-10 text-center px-6">
          <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-4">{t('home_cta_discover_badge')}</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-3">{t('home_cta_discover_title')}</h2>
          <p className="text-white/50 text-base max-w-xl mx-auto">{t('home_cta_discover_sub')}</p>
        </div>
      </section>

      {/* Main CTA - Blueprint */}
      <section className="relative py-28 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=mystical%20spiritual%20ritual%20candles%20crystals%20incense%20smoke%20dark%20purple%20cosmic%20background%20sacred%20ceremony%20spiritual%20guidance%20divine%20light%20ethereal%20atmosphere%20transformation%20awakening&width=1920&height=700&seq=cta2&orientation=landscape"
            alt="Spiritual blueprint"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#050010]/90 via-[#050010]/75 to-[#050010]/90" />
        </div>
        <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12 text-center">
          <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-4">{t('home_cta_blueprint_badge')}</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-5 max-w-3xl mx-auto leading-tight">
            {t('home_cta_blueprint_title')}{' '}
            <span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">
              {t('home_cta_blueprint_title2')}
            </span>
          </h2>
          <p className="text-white/50 text-base max-w-2xl mx-auto mb-10">
            {t('home_cta_blueprint_sub')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/consultations"
              className="flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-bold rounded-full text-sm whitespace-nowrap hover:opacity-90 transition-opacity cursor-pointer"
            >
              <i className="ri-calendar-line" />
              {t('home_cta_book_consult')}
            </Link>
            <Link
              to="/blog"
              className="flex items-center gap-2 px-8 py-4 border border-violet-500/30 text-violet-300 font-medium rounded-full text-sm whitespace-nowrap hover:bg-violet-500/10 transition-colors cursor-pointer"
            >
              <i className="ri-download-line" />
              {t('home_cta_blueprints')}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};
